import { createSlice } from '@reduxjs/toolkit';
import { ITuition } from '~/utils/interface/tuition';
import { createTuition, getListTuitions } from './tuitionThunk';
import { RootState } from '~/utils/redux/store';
import { stat } from 'fs';
import { DEFAULT_PAGE } from '~/utils/constants/common';

interface TuitionState {
  tuitions: ITuition[];
  isRefreshListTuition: boolean;
  isLoadingCreateTuition: boolean;
  currentPage: number;
  hasMore: boolean;
  isLoading: boolean;
}

const initialState: TuitionState = {
  tuitions: [],
  isRefreshListTuition: false,
  isLoadingCreateTuition: false,
  currentPage: DEFAULT_PAGE,
  hasMore: false,
  isLoading: false,
};

const tuitionSlice = createSlice({
  name: 'tuitionSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.tuitions = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListTuitions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListTuitions.fulfilled, (state, action) => {
        state.tuitions = action.payload.responses;
        state.isLoading = false;
        state.hasMore = action.payload.pagination.page < action.payload.pagination.totalPages;
        state.currentPage = action.payload.pagination.page;
      })
      .addCase(getListTuitions.rejected, (state) => {
        state.isLoading = false;
      })

      // create tuition
      .addCase(createTuition.pending, (state) => {
        state.isLoadingCreateTuition = true;
      })
      .addCase(createTuition.fulfilled, (state, action) => {
        state.isRefreshListTuition = true;
        state.isLoadingCreateTuition = false;
      })
      .addCase(createTuition.rejected, (state) => {
        state.isLoadingCreateTuition = false;
      });
  },
});

// Action
export const tuitionAction = tuitionSlice.actions;

// Selectors
export const selectTuitions = (state: RootState) => state.tuitionState.tuitions;
export const selectIsRefreshListTuition = (state: RootState) => state.tuitionState.isRefreshListTuition;

// Reducer
const tuitionReducer = tuitionSlice.reducer;
export default tuitionReducer;
